<script lang="ts">
	export let description: string;
	export let title: string;
	export let image: string = 'https://erlebenwasverbindet.telekom.de/images/header-stage.png';

	export let indexed = true;
</script>

<svelte:head>
	<title>{title}</title>
	<meta name="viewport" content="width=device-width, initial-scale=1" />
	<meta charSet="utf-8" />
	<meta name="description" content={description} />
	{#if indexed}
		<meta name="robots" content="index,follow" />
	{:else}
		<meta name="robots" content="noindex, nofollow" />
	{/if}
	<meta name="google-site-verification" content="dMLXxsnGhPIci1Z-DOK4R_hwT42wvdrvpkA5AxV33Zg" />

	<!-- Twitter -->
	<meta name="twitter:card" content="summary" />

	<!-- Open Graph -->
	<meta property="og:type" content="Website" />
	<meta property="og:site_name" content={title} />
	<meta property="og:title" content={title} />
	<meta property="og:description" content={description} />
	<meta property="og:image" content={image} />
</svelte:head>
